import type { ItemPrototypeFeature } from "~/common/interfaces/entities/item-prototype-feature.interface";

export const getItemPrototypeFeatureDefault = (): ItemPrototypeFeature => ({
	id: 0,
	onFirstPage: false,
	useCustomText: false,
	customTextPrice: 0
});
